import ExportSubscriberContent from './ExportSubscriberContent';

const exportSubscriber = {
  name: 'Export subscriber',
  Content: ExportSubscriberContent,
  setInitialContent: (content = {}) => {
    return {
      email: content.email || ''
    };
  },
  valid: content => {
    return Boolean(content.email);
  }
};

export default exportSubscriber;
